<template>
  <div class="dh-psy-ingress">
    <Paragraph :content="content" :isIngress="true" />
  </div>
</template>

<script>
import Paragraph from '../Typography/Paragraph.vue'

export default {
  data() {
    return {
      content: {
        item: {
          value: this.$root.$data.props.doc.ingress
        }
      }
    }
  },
  components: {
    Paragraph
  }
}
</script>

<style scoped lang="postcss">
  .dh-psy-ingress {
    margin: 1em 0;
  }
</style>
